interface IconProps {
  width: string
  height: string
  icon?: string | null
  onClick?: () => void
}

export const PlayIcon = (props: IconProps) => {
  return props.icon ? (
    <img
      src={props.icon}
      alt="play icon"
      width={props.width}
      height={props.height}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <rect width="48" height="48" fill="black" fillOpacity="0.5" />
        <path
          d="M19.36 16.3547L32.3562 24L19.36 31.6447V16.3547ZM18 14V34L35 24L18 14Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const VolumeOffIcon = (props: IconProps) => {
  return props.icon ? (
    <img
      src={props.icon}
      alt="volume off icon"
      width={props.width}
      height={props.height}
      onClick={props.onClick}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        d="M11.5451 5.0889C11.1806 4.92579 10.7522 4.99074 10.4536 5.25407L6.17675 9.02381H3.52112C2.68102 9.02381 2 9.69948 2 10.5047V13.4948C2 14.3283 2.68102 14.9757 3.52112 14.9757H6.17802L10.453 18.7455C10.6426 18.9125 10.8834 19 11.1267 19C11.2674 19 11.4111 18.9705 11.5441 18.9106C11.9085 18.7485 12.1405 18.3899 12.1405 17.9937V6.00542C12.1123 5.60958 11.9095 5.25083 11.5451 5.0889ZM18.2855 12.0139L19.7759 10.5352C20.073 10.2404 20.073 9.763 19.7759 9.46807C19.4788 9.17315 18.9976 9.17331 18.7004 9.46807L17.2112 10.9763L15.6933 9.49543C15.3962 9.20066 14.915 9.20066 14.6177 9.49543C14.3205 9.79019 14.3206 10.2676 14.6177 10.5626L16.1081 12.0412L14.6177 13.5199C14.3206 13.8147 14.3206 14.2921 14.6177 14.5871C14.9148 14.8818 15.396 14.882 15.6933 14.5871L17.2112 13.1081L18.7016 14.5867C18.9987 14.8814 19.4799 14.8817 19.7772 14.5867C20.0743 14.292 20.0743 13.8145 19.7772 13.5196L18.2855 12.0139Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const VolumeOnIcon = (props: IconProps) => {
  return props.icon ? (
    <img
      src={props.icon}
      alt="volume on icon"
      width={props.width}
      height={props.height}
      onClick={props.onClick}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        d="M14.8938 9.68748C14.5725 9.42704 14.0997 9.47289 13.8391 9.79379C13.5764 10.1138 13.6233 10.586 13.9445 10.8482C14.2969 11.1375 14.5 11.5562 14.5 11.9719C14.5 12.4147 14.2969 12.834 13.9434 13.1228C13.6222 13.3852 13.5753 13.8572 13.838 14.1772C13.9854 14.3586 14.2011 14.4522 14.418 14.4522C14.585 14.4522 14.7539 14.3966 14.8927 14.2835C15.5969 13.7344 16 12.8937 16 11.9719C16 11.05 15.5969 10.2625 14.8938 9.68748ZM16.7844 7.38123C16.465 7.12079 15.9925 7.16567 15.7288 7.48561C15.4661 7.80561 15.5129 8.27779 15.8333 8.53998C16.8938 9.37811 17.5 10.6656 17.5 11.9719C17.5 13.2781 16.8925 14.5375 15.8341 15.4312C15.5138 15.6936 15.4669 16.1656 15.7296 16.4856C15.878 16.6661 16.0927 16.7597 16.3096 16.7597C16.4775 16.7597 16.6455 16.7041 16.7852 16.59C18.1938 15.4656 19 13.7812 19 11.9719C19 10.1625 18.1938 8.53123 16.7844 7.38123ZM18.7 5.04373C18.3806 4.78329 17.9081 4.82914 17.6444 5.14811C17.3817 5.46811 17.4286 5.94029 17.7489 6.20248C19.4969 7.63436 20.5 9.74686 20.5 11.9719C20.5 14.1969 19.4972 16.3375 17.7481 17.7687C17.4278 18.0311 17.3809 18.5031 17.6436 18.8231C17.7906 19.0312 18.0063 19.125 18.225 19.125C18.393 19.125 18.5609 19.0694 18.7006 18.9553C20.7969 17.2375 22 14.7031 22 11.9719C22 9.24061 20.7969 6.76061 18.7 5.04373ZM11.4125 5.09311C11.0531 4.9312 10.6309 4.99698 10.3366 5.25842L6.11875 9.00311H3.5C2.67156 9.00311 2 9.67436 2 10.5019V13.4994C2 14.3269 2.67156 14.9981 3.5 14.9981H6.12L10.3356 18.7419C10.5219 18.9062 10.7594 18.9937 11 18.9937C11.1387 18.9937 11.28 18.9646 11.4113 18.9051C11.7719 18.7437 12 18.3875 12 17.9969V6.00373C12 5.61092 11.7719 5.25404 11.4125 5.09311Z"
        fill="white"
      />
    </svg>
  )
}
